import { faTimesSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";

const Modal = () => {
  const [showModal, setShowModal] = useState(true);
  return (
    <>
      {showModal ? (
        <>
          <div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center items-center sm:p-0">

                <div className="relative transform overflow-hidden rounded text-left shadow-xl transition-all sm:my-8 sm:w-full w-96 sm:max-w-lg">
                  <div className="">
                    <div className="flex absolute justify-end w-full float-right" style={{zIndex:1000}}>
                      <FontAwesomeIcon icon={faTimesSquare} className="mr-2 my-2" onClick={() => setShowModal(false)} style={{ 'cursor': 'pointer', 'fontSize': '22pt','color':'red' }} />
                    </div>
                    <div className="flex items-start">
                      <img src="./img/news/prevencion-llamadas.jpeg" alt="Formulario" />
                       {/* <div>
                         <Carousel autoPlay={true} interval={5000} infiniteLoop={true} children={false} showThumbs={false} showStatus={false} >
                            <img src="./img/slider/slider1.jpg" alt="" style={{ "height": "100%", "objectFit": "cover" }} />
                            <img src="./img/slider/slider2.jpg" alt="" style={{ "height": "100%","objectFit":"cover" }} />
                            <img src="./img/slider/slider3.jpg" alt="" style={{ "height": "100%","objectFit":"cover" }} />
                          </Carousel>
                       </div> */}
                      {/* <Link to="/registro-voluntarios">
                        <img src="./img/news/inscripcion-voluntarios-10ma-promocion.jpeg" alt="Formulario" />
                      </Link> */}
                      {/* <img src="./img/rendicion/difusion-formulario.jpeg" alt="Formulario" />
                      <a href="https://forms.gle/3SZpPzdFsVoqE1W2A" target="_blank" rel="noreferrer"
                        style={{
                          "background": "transparent", "position": "absolute", "bottom": "0", "height": "100pt", "width": "25%",
                          "cursor": "pointer", "marginLeft": "0", "marginRight": "0", "left": "auto"
                        }}>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default Modal;